import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="border-l-4 border-gold-500 pl-6 sm:pl-10 py-2" data-id="element-125">
          <p className="text-2xl sm:text-3xl font-serif text-white mb-8 leading-relaxed" data-id="element-126">
            Déjame adivinar.
          </p>

          <div className="space-y-6 text-lg sm:text-xl text-slate-300 font-light leading-relaxed" data-id="element-127">
            <p data-id="element-128">
              Ya compraste un curso. Viste horas de YouTube. Quizás incluso
              pagaste por una mentoría.
            </p>
            <p className="font-medium text-white" data-id="element-129">Y aún así... nada.</p>
            <p data-id="element-130">
              Tu enlace de afiliado sigue sin clics. Tu lista de correos
              responde con silencio. Tus publicaciones tienen likes, pero cero
              ventas.
            </p>
            <p data-id="element-131">
              Y lo más frustrante no es el dinero que no entra — es esa voz en
              tu cabeza que ya empieza a susurrar:{' '}
              <span className="italic text-slate-400" data-id="element-132">
                «¿Y si esto no es para mí?»
              </span>
            </p>
            <p className="pt-6 border-t border-white/10" data-id="element-133">
              Pero antes de que cierres esta página y vuelvas a buscar otro
              curso, necesitas escuchar algo:
            </p>
            <p className="text-2xl font-serif text-gold-400 font-medium" data-id="element-134">
              El problema no eres tú. Es que nadie te ha dado el sistema
              completo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}